import { BuyTokenPackageDialogProps } from '@/components/BuyTokenPackageDialog'
import { BuyVipDialogV1Props } from '@/components/BuyVipDialogV1'
import { ExchangeCodeDialogProps } from '@/components/ExchangeCodeDialog'
import { PaySuccessDialogProps } from '@/components/PaySuccessDialog'
import { PaySuccessEducationDiaLogProps } from '@/components/PaySuccessEducationDiaLog'
import { PdfUpgradeModalProps } from '@/components/PdfUpgradeModal'
import { FeatureType, userService } from '@/services/userService'
import { ModalProps } from 'antd'
import { MessageInstance } from 'antd/es/message/interface'
import { makeObservable, observable } from 'mobx'

import { PdfLimitModalProps } from '@/components/PdfLimitModal'
import { buyVipService } from '@/services/buyVipService'

import { commonUtils } from '@/helpers/commonUtils'
import { TranslateHelperTypes } from '@/pages/PdfPro/TranslateUtil/types'

interface CommonModalProps extends ModalProps {
  content?: string
}
class UiController {
  @observable message!: MessageInstance
  @observable commonModalProps: CommonModalProps = { open: false }
  @observable paySuccessDialogProps: PaySuccessDialogProps = {
    open: false,
  }

  @observable paySuccessEducationDialogProps: PaySuccessEducationDiaLogProps = {
    open: false,
  }

  @observable buyTokenPackageDialogProps: BuyTokenPackageDialogProps = {
    open: false,
    source: '',
    type: 'ai_llm',
  }

  @observable buyVipDialogV1Props: BuyVipDialogV1Props = {
    open: false,
    source: '',
  }

  @observable exchangeDialogProps: ExchangeCodeDialogProps = {
    open: false,
  }
  @observable pdfUploadTimeLimitedProps: PdfUpgradeModalProps = {
    open: false,
  }
  @observable pdfChatTimeLimited = false
  @observable pdfUploadPageLimitedProps: PdfUpgradeModalProps = {
    open: false,
  }

  @observable loginModalProps: {
    open: boolean
    showLeftBanner?: boolean
    handleLoginSuccess?: () => void
    giftUserProPlus?: 0 | 1
    handleNewUser?: () => void
  } = {
    open: false,
  }

  @observable operationRecordModalVisible = false

  @observable showDiscountModal = false
  @observable showPayQr = false
  @observable payQrSuccess?: (enableGiftReceiveBtn: boolean) => void = undefined
  @observable showPayQrFrom = ''
  @observable feature?: string = undefined
  @observable discount: ServerDataTypes.FormatPlan | undefined = undefined
  @observable payQrSource: string = 'pay_qr_dialog'
  @observable enableDiscountCode = false
  @observable discountEndTime: number | undefined = undefined
  @observable showPhoneNumberModal = false

  @observable pdfLimitModalProps: PdfLimitModalProps = {
    open: false,
  }

  @observable showUserRegisterSuccessModal = false

  @observable compareDialogData: {
    text: string
    rect: DOMRect
    useType: PostDataTypes.UseType
    replaceTagHtmlList: string[]
    translateEl: HTMLElement
  } | null = null

  @observable payDialogByFeature: {
    open: boolean
    feature: FeatureType
    vipType: ServerDataTypes.VersionType
    source: string
    from?: string
    enableDiscountCode?: boolean
    paySuccess?: (enableReceiveGift: boolean) => void
    showVideoActivity?: boolean
  } = {
    open: false,
    feature: 'other',
    vipType: 'max',
    source: '',
    enableDiscountCode: false,
  }

  @observable showPayVipUpgradeDialog: {
    open: boolean
    source?: string
    from?: string
    planUpgrade?: PostDataTypes.UpgradePlan
    paySuccess?: (enableGiftReceiveBtn: boolean) => void
  } = {
    open: false,
    planUpgrade: undefined,
    source: '',
    from: '',
  }

  public init() {
    makeObservable(this)
  }

  public async checkNewUserDiscount() {
    const { dataList } = await buyVipService.getUserWelfare()
    const discountPlan = dataList.find((item) => item.version === 'max') || dataList[0]
    if (!discountPlan) {
      this.discount = undefined
      return false
    }

    if (userService.userData && userService.userData.newUserDiscount) {
      const discountEndTime = userService.userData.createdAt * 1000 + 48 * 60 * 60 * 1000

      if (discountEndTime > Date.now()) {
        this.discountEndTime = discountEndTime

        const getUserRecordStr = (str: string) => {
          return `${str}_B`
        }

        userService.trackUserRecord(getUserRecordStr('show_new_user_discount_w'))
        this.discount = commonUtils.formatDiscountPlan(discountPlan)

        return true
      }
    }

    return false
  }

  public async openDiscount() {
    const showDiscount = await this.checkNewUserDiscount()
    if (showDiscount) {
      this.showPayQr = true
    }
  }

  public async openDiscountOrClose() {
    const showDiscount = await this.checkNewUserDiscount()
    if (showDiscount) {
      this.showDiscountModal = true
    } else {
      this.closeLoginModal()
    }
  }

  public async loginSuccess() {
    const userInfo = userService.userData
    await userService.updateUserInfo()

    // 注册时间
    const registerTime = userInfo!.createdAt * 1000
    // 当前时间
    const currentTime = Date.now()
    if (currentTime - registerTime < 60 * 1000 && !userInfo?.phoneNumber) {
      // 刚注册的用户，填写手机号
      this.showPhoneNumberModal = true
      uiController.loginModalProps.handleNewUser?.()
    } else {
      this.openDiscountOrClose()
    }
  }

  public closeLoginModal() {
    uiController.loginModalProps.handleLoginSuccess?.()
    uiController.loginModalProps = {
      open: false,
    }
  }

  public compareModelClick(r: TranslateHelperTypes.Paragraph, useType: PostDataTypes.UseType) {
    console.log('~~~~~~~~~~~~compareModelClick', r)
    const rect = r.translateElWrapper.getBoundingClientRect()
    const text = r.originalText || r.text
    const replaceTagHtmlList = r.replaceTagHtmlList
    const translateEl = r.translateEl
    const data = {
      text,
      rect,
      useType,
      replaceTagHtmlList,
      translateEl,
    }

    console.log('~~~~~~~~~~~~')

    // 数据不存在，则设置数据
    if (!this.compareDialogData) {
      // console.log('设置数据', text, rect, useType)
      this.compareDialogData = data
      return
    }

    // 数据存在，则比较数据
    if (
      this.compareDialogData.text === text &&
      this.compareDialogData.useType === useType &&
      this.compareDialogData.rect.top === rect.top &&
      this.compareDialogData.rect.left === rect.left
    ) {
      // 数据相同，认为是点击了同一个按钮
      // 不进行任何操作
      // console.log('数据相同，认为是点击了同一个按钮')
      return
    }

    // 先关闭弹窗
    this.compareDialogData = null

    // 再设置数据
    setTimeout(() => {
      // console.log('新数据~~', text, rect, useType)
      this.compareDialogData = data
    }, 100)
  }
}

export const uiController = new UiController()
